module.exports = __webpack_public_path__ + "img/not-impacted.c3dad9f0.svg";